import { useQuery } from '@tanstack/react-query';
import { http } from './http';

interface PriceEntry {
  symbol: string;
  value: number;
  updatedAt: string;
}

export const useSolPrice = () => {
  return useQuery({
    queryKey: ['prices'],
    queryFn: () => http.get<{ prices: PriceEntry[] }>('/prices'),
    select: (data) => data.prices.find((p) => p.symbol === 'SOL')?.value ?? 0,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
};
